module.exports = __webpack_public_path__ + "static/media/questionmark.1760b588.svg";